module.exports = __webpack_public_path__ + "img/TrialPitDimensions.6dbb4185.jpg";